import React, { useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Grid, Select, MenuItem, OutlinedInput, FormHelperText, FormControl
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useFormularioInscricao from './useFormularioInscricao';
import ContainedButton from '../../../shared/buttons/ContainedButton';
import TextButton from '../../../shared/buttons/TextButton';
import Close from '@material-ui/icons/CloseOutlined';
import Save from '@material-ui/icons/SaveOutlined';
import * as Yup from 'yup';
import LabelValue from "../../../shared/labelvalue/LabelValue.js";

const useStyles = makeStyles(theme => ({
    dialogContent: {
        paddingTop: theme.spacing(2)
    }
}));

const validationSchema = Yup.object().shape({
    nome: Yup.string().required('Campo obrigatório'),
    grauParentescoId: Yup.number().typeError('Campo obrigatório').required('Campo obrigatório'),
    bolsa: Yup.string().required('Campo obrigatório')
});

export default function DialogParenteBeneficiario({ open, onClose, onSave, initialValues, grausParentesco = [] }) {
    const classes = useStyles();

    const formDialogo = useFormularioInscricao({
        valoresIniciais: { nome: '', grauParentescoId: '', bolsa: '' },
        schema: validationSchema,
        aoSubmeter: (values) => {
            onSave(values);
        }
    });

    useEffect(() => {
        if (open) {
            formDialogo.reiniciar({
                values: initialValues ? {
                    ...initialValues,
                    grauParentescoId: initialValues.grauParentesco?.id ?? ''
                } : { nome: '', grauParentescoId: '', bolsa: '' }
            });
        }
    }, [open, initialValues]);

    return (
        <Dialog scroll="body" open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{initialValues && initialValues.nome ? 'Editar Parente Beneficiário' : 'Adicionar Parente Beneficiário'}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LabelValue label="Nome do Parente *">
                            <FormControl variant="outlined" fullWidth error={formDialogo.tocados.nome && !!formDialogo.erros.nome}>
                                <OutlinedInput
                                    name="nome"
                                    value={formDialogo.valores.nome}
                                    onChange={formDialogo.aoMudar}
                                    onBlur={formDialogo.aoSair}
                                />
                                {formDialogo.tocados.nome && formDialogo.erros.nome && (
                                    <FormHelperText>{formDialogo.erros.nome}</FormHelperText>
                                )}
                            </FormControl>
                        </LabelValue>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LabelValue label="Grau de Parentesco *">
                            <FormControl variant="outlined" fullWidth error={formDialogo.tocados.grauParentescoId && !!formDialogo.erros.grauParentescoId}>
                                <Select
                                    name="grauParentescoId"
                                    value={formDialogo.valores.grauParentescoId}
                                    onChange={formDialogo.aoMudar}
                                    onBlur={formDialogo.aoSair}
                                >
                                    <MenuItem value="">Selecione...</MenuItem>
                                    {grausParentesco.map(item => (
                                        <MenuItem key={item.id} value={item.id}>{item.descricao}</MenuItem>
                                    ))}
                                </Select>
                                {formDialogo.tocados.grauParentescoId && formDialogo.erros.grauParentescoId && (
                                    <FormHelperText>{formDialogo.erros.grauParentescoId}</FormHelperText>
                                )}
                            </FormControl>
                        </LabelValue>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LabelValue label="Tipo de Bolsa / Desconto *">
                            <FormControl variant="outlined" fullWidth error={formDialogo.tocados.bolsa && !!formDialogo.erros.bolsa}>
                                <OutlinedInput
                                    name="bolsa"
                                    value={formDialogo.valores.bolsa}
                                    onChange={formDialogo.aoMudar}
                                    onBlur={formDialogo.aoSair}
                                    placeholder="Ex: ProUni 50%, AERP 100%"
                                />
                                {formDialogo.tocados.bolsa && formDialogo.erros.bolsa && (
                                    <FormHelperText>{formDialogo.erros.bolsa}</FormHelperText>
                                )}
                            </FormControl>
                        </LabelValue>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose} startIcon={<Close />}>Fechar</TextButton>
                <ContainedButton onClick={formDialogo.submeter} startIcon={<Save />} disabled={formDialogo.enviando}>
                    Salvar
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}
